import { OrderReportDto } from '@core/dto';
import { GroupsCatalog, SubGroupCatalog } from '@core/interfaces';
import { DateRangeInterface, DateSingleInterface } from '@core/interfaces/date-range.interface';
import { ReportGroupByEnum } from '../../../pages/analyze/enums';
import { SuperSearch } from '../../../pages/orders/interfaces/schGraph.interface';
import { IStatus } from './indicator-status.interface';
import { PlantListInterface } from './PlantListInterface';

export interface IFilters {
  dateRange: DateRangeInterface;
  dates?: DateRangeInterface;
  rangeChanged?: boolean;
  time: TimeClassification;
  timeChanged?: boolean;
  groupBy: ReportGroupByEnum;
  search: string;
  searchChanged?: boolean;
  selectedStatus: IStatus[];
  statusChanged?: boolean;
  groupId: number;
  subGroupId: number;
  plants: number[] | string[];
  plantsChanged?: boolean;
  selectedRow: OrderReportDto | null;
  response: OrderReportDto[];
  fieldToOrder: string;
  fieldTypeToOrder: string;
  fieldSortAsc: boolean;
  ordersOrderSort: string;
  ordersCustomerSort: string;
  ordersJobsiteSort: string;
  ordersPointOfDeliverySort?: string;
  ordersProductShortDescSort: string;
  ordersConfirmQuantitySort: string;
  ordersDeliveryDateTimeSort: string;
  orderCode?: string;
  orderCodeChanged?: boolean;
  additionalServices?: boolean;
  sellCollector?: boolean;
  renegotiated?: boolean;
  extraProduct?: boolean;
  waitingList?: boolean;
  cashOnDelivery?: boolean;
  pumpService?: boolean;
  customerName?: string;
  jobsiteName?: string;
  pointOfDelivery?: string;
  productDescription?: string;
  documentCode?: string;
  groupList?: GroupsCatalog[];
  subGroupList?: SubGroupCatalog[];
  plantList?: PlantListInterface[];
}

export enum TimeClassification {
  currentDay = 0,
  weekToDate = 1,
  monthToDate = 2,
  noStatus = null,
}

export interface SchGraFilters {
  dateRange: DateSingleInterface;
  rangeChanged?: boolean;
  plants: number[];
  plantsChanged?: boolean;
  search: SuperSearch;
  searchChanged?: boolean;
}
